const state = {
    profile: []
}
const mutations = {
    profile(state, profile) {
        state.profile = profile;
    }

}
const actions = {
    getProfile({
        commit
    }, App) {
        App.Vue.$http.post(App.url, App.data)
            .then(
                response => {
                    if (response.body.resultado !== "NO") {
                        commit('profile', response.body)
                        console.log(response.body);
                    } else {
                        commit('profile', []);
                        //    this.noData = true;
                    }
                },
                () => {
                    commit('profile', []);
                }
            );

    },

}
const getters = {
    profile: state => {
        return state.profile
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}